export const SCRATCH = "SCRATCH";
export const WOOF = "WOOF";
export const WEB = "WEB";
export const ADVENTURE = "ADVENTURE";
export const PUZZLE = "PUZZLE";
export const ARCADE = "ARCADE";
export const MULTIPLAYER = "MULTIPLAYER";
export const INTRO2 = "INTRO TO SCRATCH";
export const INTRO1 = "INTRO TO CODING";
export const PYTHON = "PYTHON";
export const CHALLENGES = "CHALLENGES";
export const AI = "AI";
export const UNITY = "UNITY";
export const DATA_SCIENCE = "DATA SCIENCE";
// export const ML_FOR_KIDS = "ML FOR KIDS";
// export const DIGITAL_ART = "DIGITAL ART";
export const ROBOTICS = "ROBOTICS";
// export const ARTIFICIAL_INTELLIGENCE = "ARTIFICIAL INTELLIGENCE";
